/**
 * URL de compartir estudio vía ticket ?t= (+ ticketApi + edge_id origen).
 * Solo parámetros de portal paciente — sin udvToken/plan/shell/persona clínica.
 */
import { EDGE_ID_QUERY_KEY, TICKET_QUERY_KEY } from '../plan/constants'
import { parseEdgeIdFromSearchParams } from '../plan/parsePlanQuery'
import { parseClinicNameFromSearchParams } from './resolveStudyCatalogOrigin'

/**
 * @param {{ ticketId?: string, ticketApi?: string, edgeId?: string|null, clinicName?: string|null }} [opts]
 * @returns {string}
 */
export function buildStudyShareUrl(opts = {}) {
  if (typeof window === 'undefined') return ''
  const ticketId = opts.ticketId != null ? String(opts.ticketId).trim() : ''
  if (!ticketId) return ''

  const origin = window.location.origin
  const path = window.location.pathname || '/'
  const url = new URL(origin + path)
  url.searchParams.set(TICKET_QUERY_KEY, ticketId)

  const ticketApi = opts.ticketApi != null ? String(opts.ticketApi).trim() : ''
  if (ticketApi && /^https?:\/\//i.test(ticketApi)) {
    url.searchParams.set('ticketApi', ticketApi.replace(/\/+$/, ''))
  }

  let edgeId =
    opts.edgeId != null && String(opts.edgeId).trim() !== ''
      ? String(opts.edgeId).trim()
      : null
  if (!edgeId && typeof window !== 'undefined') {
    edgeId = parseEdgeIdFromSearchParams(
      new URLSearchParams(window.location.search)
    )
  }
  if (edgeId) {
    url.searchParams.set(EDGE_ID_QUERY_KEY, edgeId)
  }

  let clinicName =
    opts.clinicName != null && String(opts.clinicName).trim() !== ''
      ? String(opts.clinicName).trim()
      : null
  if (!clinicName && typeof window !== 'undefined') {
    clinicName = parseClinicNameFromSearchParams(
      new URLSearchParams(window.location.search)
    )
  }
  if (clinicName) {
    url.searchParams.set('clinic_name', clinicName)
  }

  return url.toString()
}

/**
 * @param {string} text
 * @returns {Promise<boolean>}
 */
export async function copyTextToClipboard(text) {
  const value = String(text || '')
  if (!value) return false
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(value)
      return true
    }
  } catch (e) {
    /* fallback */
  }
  try {
    const ta = document.createElement('textarea')
    ta.value = value
    ta.setAttribute('readonly', '')
    ta.style.position = 'fixed'
    ta.style.left = '-9999px'
    document.body.appendChild(ta)
    ta.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(ta)
    return ok
  } catch (e2) {
    return false
  }
}

/**
 * @param {string} text
 * @param {{ width?: number, margin?: number }} [opts]
 * @returns {Promise<string|null>} data URL PNG
 */
export async function qrDataUrlForText(text, opts = {}) {
  const value = String(text || '').trim()
  if (!value) return null
  try {
    const QRCode = (await import('qrcode')).default
    return await QRCode.toDataURL(value, {
      width: opts.width != null ? opts.width : 200,
      margin: opts.margin != null ? opts.margin : 2,
      errorCorrectionLevel: 'M',
    })
  } catch (e) {
    console.warn('[studyShareLink] qrDataUrlForText', e)
    return null
  }
}
